import styled from 'styled-components'

export const Container = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2.12rem;
`

export const Section = styled.section`
  padding: 0 3rem 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-radius: 0.5rem;
`

export const Divider = styled.div`
  background-color: ${(props) => props.theme.color.neutral.background};
  height: 1.38rem;
  width: 200%;
`

export const Title = styled.h2`
  font-size: ${(props) => props.theme.font.textcaption};
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 0.75rem */
  letter-spacing: 0.00188rem;
  color: ${(props) => props.theme.color.neutral.black};
`

export const Row = styled.div`
  display: flex;
  gap: 1rem;
`

export const AddButtonContainer = styled.div`
  width: 45%;
  max-width: 15rem;
  align-self: flex-end;
`

export const RemoveButtonContainer = styled.div`
  width: 35%;
  max-width: 12rem;
  align-self: flex-end;
`

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const PlaceHolderFile = styled.p`
  width: 100%;
  margin-left: 1rem;
  font-size: ${(props) => props.theme.font.textcaption};
  position: absolute;
  cursor: pointer;
`

export const TextAreaContainer = styled.div`
  .ql-container {
    border-bottom-left-radius: 0.5em;
    border-bottom-right-radius: 0.5em;
    background: #fefcfc;
  }

  .ql-snow.ql-toolbar {
    display: block;
    background: #eaecec;
    border-top-left-radius: 0.5em;
    border-top-right-radius: 0.5em;
  }

  .ql-editor {
    min-height: 18em;
  }
`

export const ButtonContainer = styled.div`
  width: 45%;
  max-width: 15rem;
  align-self: flex-end;
`
